module.exports = __webpack_public_path__ + "img/elevator-undefined.882bbc0f.png";